
(function () {
    'use strict';

    angular
        .module('app')
        .factory('utilService', [utilService]);

    function utilService() {

        var errorEnum = {
            ALL: 0,
            VALIDATIONS: 1,
            EXCEPTIONS: 2
        }

        var parseViewModelResponse = function(resp, errorEnum) {
            switch (errorEnum) {
                case 0:
                    return parseValidations(resp).concat(parseExceptions(resp));
                case 1:
                    return parseValidations(resp);
                case 2:
                    return parseExceptions(resp);
                default:
                    return [];
            }
        };

        var parseValidations = function (resp) {

            var validationErrors = [];

            if (resp && resp.data && resp.data.modelState) {
                _.forOwn(resp.data.modelState,
                    function(value, key) {
                        _.forOwn(resp.data.modelState[key],
                            function(val, idx) {
                                validationErrors.push(resp.data.modelState[key][idx]);
                            });
                    });
            }

            return validationErrors;
        };

        var parseExceptions = function (resp) {

            var exceptions = [];

            if (resp && resp.data && resp.data.exceptions) {
                _.each(resp.data.exceptions, function (error) {
                    exceptions.push(error);
                });
            }

            return exceptions;
        };

        return {
            errorEnum: errorEnum,
            parseViewModelResponse: parseViewModelResponse
        }
    };

})();